import { render, staticRenderFns } from "./staff-directory.vue?vue&type=template&id=614c484c&"
import script from "./staff-directory.vue?vue&type=script&lang=js&"
export * from "./staff-directory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports